const GA4_SCRIPT_ID = "ga4-script";

type PageViewPayload = {
  pageTitle: string;
  pagePath: string;
  pageLocation: string;
};

let initializedMeasurementID = "";

function measurementID(): string {
  return window.__APP_CONFIG__?.gaMeasurementId?.trim() || "";
}

function ensureGtagStub(): void {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === "function") {
    return;
  }
  window.gtag = (...args: unknown[]) => {
    window.dataLayer?.push(args);
  };
}

function ensureAnalyticsScript(id: string): void {
  const expectedSrc = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  const existing = document.getElementById(GA4_SCRIPT_ID) as HTMLScriptElement | null;
  if (existing && existing.src === expectedSrc) {
    return;
  }
  if (existing) {
    existing.remove();
  }

  const script = document.createElement("script");
  script.id = GA4_SCRIPT_ID;
  script.async = true;
  script.src = expectedSrc;
  document.head.appendChild(script);
}

export function initializeAnalytics(): string {
  const id = measurementID();
  if (id === "") {
    return "";
  }
  if (initializedMeasurementID === id) {
    return id;
  }

  ensureGtagStub();
  ensureAnalyticsScript(id);
  window.gtag?.("js", new Date());
  window.gtag?.("config", id, { send_page_view: false });
  initializedMeasurementID = id;
  return id;
}

export function trackPageView(payload: PageViewPayload): void {
  if (initializeAnalytics() === "") {
    return;
  }
  window.gtag?.("event", "page_view", {
    page_title: payload.pageTitle,
    page_path: payload.pagePath,
    page_location: payload.pageLocation,
  });
}

export function resetAnalyticsForTests(): void {
  initializedMeasurementID = "";
  document.getElementById(GA4_SCRIPT_ID)?.remove();
  delete window.gtag;
  delete window.dataLayer;
}
